import styled from "styled-components";
import { theme } from "../theme";

export const StyledSidemenuItem = styled.li`
	position: relative;
	padding: 0.6rem 0;
	padding-left: ${({ active }) => (active ? "1.6rem" : "0")};
	margin-top: 0.6rem;
	display: flex;
	justify-content: space-between;
	align-content: center;
	&:nth-of-type(1) {
		margin-top: 0;
	}
	&::before {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 0.1rem;
		background: ${({ active }) => (active ? theme.color.black : "#d8dcdf")};
		content: "";
	}
	&::after {
		position: absolute;
		top: 50%;
		left: 0;
		width: 0.8rem;
		height: 0.8rem;
		background: ${theme.color.black};
		border-radius: 50%;
		transform: translate(0, -50%);
		content: "";
		display: ${({ active }) => (active ? "block" : "none")};
	}
	a {
		color: ${theme.color.black};
		text-decoration: none;
	}
	img {
		width: 1.6rem;
		height: 1.6rem;
		object-fit: contain;
	}
`;
